import React from 'react';
import './PricingPage.css';

function PricingPage() {
  const commonFeatures = [
    '랭킹/단지 기본 조회 및 필터 제공',
    '즐겨찾기 그룹 관리 기능 제공',
    '주요 지표 기반의 비교 분석 화면 제공',
  ];

  const plans = [
    {
      id: 'standard',
      name: '스탠다드',
      badge: '기본',
      price: '월 9,900원',
      target: '기본 조회와 즐겨찾기 중심으로 사용하는 사용자',
      features: [
        '랭킹 페이지 기본 조회',
        '지역/평형/세대수 기본 필터',
        '즐겨찾기 등록 및 그룹 관리',
      ],
      functionsList: [
        '기본 시세 추이 확인',
        '단지 상세 정보 확인',
        '표 정렬 및 검색',
      ],
    },
    {
      id: 'pro',
      name: '프로',
      badge: '추천',
      price: '월 29,900원',
      target: '심화 지표와 비교 기능까지 활용하는 사용자',
      features: [
        '스탠다드 전체 기능 포함',
        '단지 간 비교 모달',
        '확장 지표 기반 분석',
      ],
      functionsList: [
        '고급 비교 차트',
        '추가 분석 지표 제공',
        '업데이트 기능 우선 제공',
      ],
    },
  ];

  return (
    <div className="pricing-page">
      <div className="pricing-container">
        <div className="pricing-header">
          <h1>상품소개</h1>
          <p className="pricing-subtitle">스탠다드와 프로, 두 가지 멤버십을 비교해 보세요</p>
        </div>

        <div className="common-section">
          <h2 className="section-title">공통 제공</h2>
          <ul className="common-list">
            {commonFeatures.map((feature) => (
              <li key={feature}>{feature}</li>
            ))}
          </ul>
        </div>

        <div className="pricing-cards">
          {plans.map((plan) => (
            <div key={plan.id} className="pricing-card">
              <div className="card-header">
                <div className="plan-title-section">
                  <h2 className="plan-name">{plan.name}</h2>
                  {plan.badge && <span className="plan-badge">{plan.badge}</span>}
                </div>
                <div className="plan-price">{plan.price}</div>
              </div>

              <div className="card-body">
                <div className="section-block">
                  <h3 className="block-title">추천 대상</h3>
                  <p className="target-text">{plan.target}</p>
                </div>

                <div className="section-block">
                  <h3 className="block-title">핵심 기능</h3>
                  <ul className="feature-list">
                    {plan.features.map((feature) => (
                      <li key={feature}>{feature}</li>
                    ))}
                  </ul>
                </div>

                <div className="section-block">
                  <h3 className="block-title">제공 항목</h3>
                  <ul className="function-list">
                    {plan.functionsList.map((func) => (
                      <li key={func}>{func}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PricingPage;
